export type AzureFileType = "audio" | "video" | "subtitle" | "static" | "lesson-plan";

export default class Config {
    public static AzureUrl: string;
    public static AzureKey: string;

    /**
     * Returns a complete Azure Url for a given file
     *
     * @param {string} fileKey A string for the given file. Extension is based on 'fileType' *except for static, which must have a extension attached*
     * @param {AzureFileType} fileType
     * @param {string} languageCode
     */
    public static GetAzureUrl(fileKey: string, fileType: AzureFileType, languageCode: string) {
        if (fileKey == null || fileKey.length < 1) {
            return "";
        }

        let folderPath = "";
        let fileKeyWithExtension = "";
        let lang = languageCode != null && languageCode.length > 1 ? `${languageCode.toLowerCase()}` : "";
        switch (fileType) {
            case "audio":
                folderPath = `audio/${lang}`;
                fileKeyWithExtension = `${fileKey}.mp3`;
                break;
            case "video":
                folderPath = `video/${lang}`;
                fileKeyWithExtension = `${fileKey}.mp4`;
                break;
            case "subtitle":
                folderPath = `subtitles/${lang}`;
                fileKeyWithExtension = `${fileKey}.vtt`;
                break;
            case "static":
                folderPath = `static/${lang}`;
                fileKeyWithExtension = fileKey;
                break;
            case "lesson-plan":
                folderPath = `lesson-plans/${lang}`;
                fileKeyWithExtension = fileKey;
                break;
            default:
                // JB - Clarification: The following line is fucking magic
                const exhaustiveCheck: never = fileType;
                break;
        }
        // Remove double '//'s: https://stackoverflow.com/questions/24381480/remove-duplicate-forward-slashes-from-the-url
        return `${this.AzureUrl}/${folderPath}/${fileKeyWithExtension}${this.AzureKey}`
            .replace(/([^:])(\/\/+)/g, '$1/'); // Remove duplicate slashes
    }
}



// WEBPACK FOOTER //
// ./src/constants/Config.ts